<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: [Number, String],
    default: 24,
  },
  variant: {
    type: String,
    default: 'brand',
    validator: v => ['brand', 'automated'].includes(v),
  },
});

const colors = computed(() => {
  if (props.variant === 'automated') {
    return {
      bgFrom: '#c4a97a',
      bgTo: '#a08050',
      sparkle: '#fff',
      sparkleOpacity: 0.85,
      miniOpacity: 0.4,
    };
  }
  return {
    bgFrom: '#9B2C2C',
    bgTo: '#BE185D',
    sparkle: '#fff',
    sparkleOpacity: 0.9,
    miniOpacity: 0.5,
  };
});

const gradientId = computed(() => `brain-grad-${props.variant}`);
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient :id="gradientId" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" :stop-color="colors.bgFrom" />
        <stop offset="100%" :stop-color="colors.bgTo" />
      </linearGradient>
    </defs>
    <rect width="80" height="80" rx="18" :fill="`url(#${gradientId})`" />
    <!-- Sparkle principal -->
    <path
      d="M40 18c0 0 3 10 8 15s15 8 15 8-10 3-15 8-8 15-8 15-3-10-8-15-15-8-15-8 10-3 15-8 8-15 8-15z"
      :fill="colors.sparkle"
      :opacity="colors.sparkleOpacity"
    />
    <!-- Sparkle pequeno -->
    <path
      d="M55 22c0 0 1.5 4 3.5 6s6 3.5 6 3.5-4 1.5-6 3.5-3.5 6-3.5 6-1.5-4-3.5-6-6-3.5-6-3.5 4-1.5 6-3.5 3.5-6 3.5-6z"
      :fill="colors.sparkle"
      :opacity="colors.miniOpacity"
      transform="scale(0.6) translate(38, 8)"
    />
  </svg>
</template>
